var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 16,
    height: 16,
    transform: "translate(672 7042)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15",
    "data-name": "Mask Group 15",
    transform: "translate(-672 -7042)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(673.143 7042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M8.67,11.107v1.884q0,.6-.348.6a.573.573,0,0,1-.4-.2V10.705a.573.573,0,0,1,.4-.2Q8.67,10.509,8.67,11.107Zm3.018.009v.411h-.8v-.411q0-.607.4-.607T11.688,11.116ZM3.063,9.17h.955V8.33H1.232V9.17H2.17v5.08h.893Zm2.571,5.08h.795V9.839H5.634v3.375q-.268.375-.509.375-.161,0-.187-.187a2.485,2.485,0,0,1-.009-.313V9.839H4.134V13.33a2.208,2.208,0,0,0,.071.652.481.481,0,0,0,.518.33,1.307,1.307,0,0,0,.911-.545Zm3.83-1.321V11.17a3.175,3.175,0,0,0-.08-.884.62.62,0,0,0-.634-.5,1.075,1.075,0,0,0-.83.482V8.33H7.125v5.92H7.92v-.429a1.108,1.108,0,0,0,.83.491.618.618,0,0,0,.634-.491A3.282,3.282,0,0,0,9.464,12.929Zm3.018-.089v-.116H11.67a4.421,4.421,0,0,1-.018.545.342.342,0,0,1-.357.321q-.411,0-.411-.616V12.2h1.6v-.92a1.772,1.772,0,0,0-.241-1.036,1.221,1.221,0,0,0-1.9,0,1.722,1.722,0,0,0-.25,1.036v1.545a1.677,1.677,0,0,0,.259,1.036,1.146,1.146,0,0,0,.964.455,1.105,1.105,0,0,0,1.152-.955A3.931,3.931,0,0,0,12.482,12.839ZM7.054,4.688V2.813q0-.616-.384-.616t-.384.616V4.688q0,.625.384.625T7.054,4.688Zm6.42,6.705a15.47,15.47,0,0,1-.232,3.125,1.7,1.7,0,0,1-.518.884,1.562,1.562,0,0,1-.911.411A47.74,47.74,0,0,1,6.857,16,47.74,47.74,0,0,1,1.9,15.813,1.583,1.583,0,0,1,.987,15.4a1.632,1.632,0,0,1-.513-.884,15.151,15.151,0,0,1-.232-3.125A15.47,15.47,0,0,1,.473,8.268a1.7,1.7,0,0,1,.518-.884,1.619,1.619,0,0,1,.92-.42q1.634-.179,4.946-.179t4.955.179a1.677,1.677,0,0,1,1.429,1.3A15.152,15.152,0,0,1,13.473,11.393ZM4.563,0h.911L4.393,3.562v2.42H3.5V3.562A15.119,15.119,0,0,0,2.955,1.67Q2.625.75,2.375,0h.946l.634,2.348Zm3.3,2.973V4.536a1.76,1.76,0,0,1-.25,1.054,1.113,1.113,0,0,1-.946.455,1.1,1.1,0,0,1-.937-.455,1.785,1.785,0,0,1-.25-1.054V2.973a1.741,1.741,0,0,1,.25-1.045,1.1,1.1,0,0,1,.938-.455,1.113,1.113,0,0,1,.946.455A1.741,1.741,0,0,1,7.866,2.973Zm2.991-1.446V5.982h-.812V5.491a1.285,1.285,0,0,1-.92.554.5.5,0,0,1-.527-.33,2.291,2.291,0,0,1-.071-.67V1.527h.813V4.8a2.339,2.339,0,0,0,.009.313q.027.2.188.2.241,0,.509-.384v-3.4Z",
    fill: "#114A65"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.25ea69ee9b867d17ad80f105261c5c78.svg";
export { ForwardRef as ReactComponent };